<template>
  <div class="form-check" :class="[{ disabled: disabled }, inlineClass]">
    <label :for="cbId" class="form-check-label">
      <input
        :id="cbId"
        @change="handleChange"
        class="form-check-input"
        type="checkbox"
        :disabled="disabled"
        v-model="model"
      />
      <span class="form-check-sign"></span>
      <slot> <span v-if="inline">&nbsp;</span> </slot>
    </label>
  </div>
</template>
<script>
export default {
  name: 'base-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    // Support Array (checkbox groups), Boolean, and common
    // backend flags like 'T' / 'F' or '0' / '1' represented as strings.
    checked: {
      type: [Array, Boolean, String, Number],
      default: false
    },
    disabled: Boolean,
    inline: Boolean,
    hasError: Boolean
  },
  data() {
    return {
      cbId: '',
      touched: false
    };
  },
  methods: {
    handleChange(evt) {
      this.$emit('change', evt);
    }
  },
  computed: {
    model: {
      get() {
        // Preserve arrays for checkbox groups
        if (Array.isArray(this.checked)) {
          return this.checked;
        }

        // Coerce string / number flags into booleans
        if (typeof this.checked === 'string') {
          const v = this.checked.toLowerCase();
          if (v === 't' || v === 'true' || v === '1' || v === 'y') return true;
          if (v === 'f' || v === 'false' || v === '0' || v === 'n' || v === '') return false;
        }

        if (typeof this.checked === 'number') {
          return this.checked !== 0;
        }

        // Fallback: boolean cast
        return !!this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit('input', check);
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>
